import { createSlice } from "@reduxjs/toolkit";
import { getCallBackById, updateCallBackById, deleteCallBack,createCallBack,getAllcallBacks } from "../../API/FormsData/callBack";

const initialState = {
    getallcallBacks: [],
    loading: false,
    error: null,
    totalPages: 0,
    currentPage: 1,
};

const callBackSlice = createSlice({
  name: "CallBack",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCallBackById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCallBackById.fulfilled, (state, action) => {
        state.loading = false;
        state.getcallBacks = [action.payload]; // Flat callBack object array
        state.error = null;
      })
      .addCase(getCallBackById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateCallBackById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCallBackById.fulfilled, (state, action) => {
        state.loading = false;
        state.updatecallBacks = [action.payload]; // Flat callBack object array
        state.error = null;
      })
      .addCase(updateCallBackById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteCallBack.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteCallBack.fulfilled, (state, action) => {
        state.loading = false;
        state.deletecallBacks = [action.payload]; // Flat callBack object array
        state.error = null;
      })
      .addCase(deleteCallBack.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllcallBacks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllcallBacks.fulfilled, (state, action) => {
        state.loading = false;
        state.getallcallBacks = action.payload.data;
        state.totalPages = action.payload.totalPages;
        state.currentPage = action.payload.page;
      })
      .addCase(getAllcallBacks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createCallBack.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createCallBack.fulfilled, (state, action) => {
        state.loading = false;
        state.createcallBacks = [action.payload]; // Flat callBack object array
        state.error = null;
      })
      .addCase(createCallBack.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default callBackSlice.reducer;